"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 3,
  y: 21,
  fill: "var(--sds--ursa-icons--selected-color, currentColor)",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m17.548 12.289-.515.474-.515-.474a.7.7 0 0 1 1.03 0m-.515 1.564q-.151.192-.311.419c-.209.295-.406.61-.549.907-.148.31-.207.538-.207.676 0 .585.482 1.067 1.067 1.067s1.067-.482 1.067-1.068c0-.138-.058-.365-.207-.675a6.6 6.6 0 0 0-.548-.907q-.16-.226-.312-.42m2.122.72c.182.38.345.832.345 1.281a2.473 2.473 0 0 1-2.467 2.468 2.47 2.47 0 0 1-2.467-2.467c0-.45.163-.902.345-1.282.189-.393.434-.777.667-1.108a13 13 0 0 1 .916-1.15l.017-.018.005-.006.003-.002.514.474.515-.474.002.002.005.006.018.019a9 9 0 0 1 .273.316c.174.208.408.5.643.833.233.33.477.715.666 1.108M8.505 3.512a.7.7 0 0 1 .99-.014l1.064 1.036 4.131 4.13a3.204 3.204 0 0 1 0 4.532l-2.36 2.36a3.204 3.204 0 0 1-4.531 0l-2.36-2.36a3.204 3.204 0 0 1 0-4.531l3.628-3.63-.549-.533a.7.7 0 0 1-.013-.99m1.56 2.507L13.7 9.655c.216.216.366.472.45.745l-8.169-.006c.084-.27.233-.525.447-.74zM6.12 11.794q.12.223.308.412l2.36 2.36a1.804 1.804 0 0 0 2.552 0l2.36-2.36q.186-.187.306-.406z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BackgroundColorWithSelectionIcon24.js.map